import { render, staticRenderFns } from "./sectionRelatedSpuSelect.vue?vue&type=template&id=5ef9cdf1&"
import script from "./sectionRelatedSpuSelect.vue?vue&type=script&lang=js&"
export * from "./sectionRelatedSpuSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports